export default "__VITE_ASSET__7f90c430__"